import { Injectable } from '@angular/core';
import { TaskResponse, Task, ProjectResponse, TaskTypeResponse, Field, FieldResponse, CreateTaskResponse, ChangeIssueStatusResponse, DetailedTaskResponse} from "../core/core.component";
import { Http, Headers, URLSearchParams} from '@angular/http'; 
import { AppConstants } from '../core/app.constants';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class TaskService
{
    private taskDetailStatus = new Subject<string>();
    private creationTaskEvent = new Subject<number>();
    private refreshTasksEvent = new Subject<Task[]>();
   
    constructor(private http: Http) { }
    
    getCreationTaskEvent() : Observable<number> {
        return this.creationTaskEvent.asObservable();
    }
    getRefreshTasksEvent() : Observable<Task[]> {
        return this.refreshTasksEvent.asObservable();
    }
    
    getTaskDetailStatus() : Observable<string> {
        return this.taskDetailStatus.asObservable();
    }
    
    notifyCreationTask(taskId: number) {
        this.creationTaskEvent.next(taskId);
    }
    
    refreshTasks(tasks: Task[]) {
        this.refreshTasksEvent.next(tasks);
    }
    
    openTaskDetail() {
        this.taskDetailStatus.next("open");
    }
    
    openTaskDetailAsPlugin() {
        this.taskDetailStatus.next("openAsPlugin");
    }

    closeTaskDetail() {
        this.taskDetailStatus.next("close");
    }
  
    getRecentTasks(srmToken, limit:number): Observable<DetailedTaskResponse> 
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues/recent";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if(limit != null && limit != 0) {
            params.set('limit', limit+"");
        }
        params.set('getDetails', 'true');
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    searchTask(srmToken, query:string, limit:number): Observable<DetailedTaskResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if(query != null && query!= "") {
            params.set('search', query);
        }
        if(limit != null && limit != 0) {
            params.set('limit', limit+"");
        }
        params.set('getDetails', 'true');
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }

    searchTaskByStatus(srmToken, status:string, limit?:number): Observable<DetailedTaskResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issuesByStatus";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if (status != null && status != '') {
            params.set('status', status);
        }
        if (limit != null && limit != 0) {
            params.set('limit', limit + '');
        }
        params.set('getDetails', 'true');
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }

    searchTaskByProject(srmToken, query:string, idProjects:string, limit:number, forceReload?:boolean): Observable<TaskResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issuesByProjects";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if (query != null && query!= '') {
            params.set('search', query);
        }
        if (idProjects != null && idProjects != '') {
            params.set('projectIDs', idProjects);
        }
        if (limit != null && limit != 0) {
            params.set('limit', limit + '');
        }
        if (forceReload != null) {
            params.set('forceReload', forceReload + '');
        }
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
    
    getUserProjects(srmToken): Observable<ProjectResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/users/projects";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
       
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    getTaskTypeForProject(srmToken, idProject: number): Observable<TaskTypeResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/projects/" + idProject + "/issuetypes";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
       
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    getCustomFields(srmToken, idProject: number, idTaskType: number): Observable<FieldResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/projects/" + idProject + "/issuetypes/" + idTaskType + "/fields";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
       
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    createTask(srmToken, idProject: number, idTaskType: number, title: string, fields: Field[]) : Observable<CreateTaskResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        
        let params = new URLSearchParams();
        params.append("project_id", idProject.toString());
        params.append("issuetype_id", idTaskType.toString());
        params.append("title", title);
        if(fields != null && fields.length > 0) {
            for(let i = 0; i < fields.length; ++i)
            {
                var name = fields[i].name;
                if(fields[i].custom == true && fields[i].values == null) {
                    name = name + "_value"; 
                }
                if(fields[i].values != null) {
                    name = name + "_id";
                }
                params.append(name, fields[i].value);
            }
        }
        
        let body = params.toString();
       
        return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    changeTaskStatus(srmToken, idTask: number, option: string): Observable<ChangeIssueStatusResponse> {
      let url = environment.REST_SERVICE_BASE_URL + '/tbg/issues/' + idTask + '/changeStatus';
      url = AppConstants.urlForNoCache(url);
      const headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      headers.append("Content-Type", "application/json; charset=UTF-8");

      const body = {option: option};

      return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    changeTaskStatusAdvanced(srmToken, idTask: number, statusNames: string[], comment: string): Observable<ChangeIssueStatusResponse> {
      let url = environment.REST_SERVICE_BASE_URL + '/tbg/issues/' + idTask + '/changeStatusAdvanced';
      url = AppConstants.urlForNoCache(url);
      const headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      headers.append("Content-Type", "application/json; charset=UTF-8");

      const body = {statusNames: statusNames, comment: comment};

      return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    getIssueById(srmToken, issueId: number, idProjects, details: boolean): Observable<DetailedTaskResponse>
    {
        var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues/" + issueId+"/getIssue";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        params.set('getDetails', details ? 'true' : 'false');
        if (idProjects != null && idProjects != '') {
            params.set('projectIDs', idProjects);
        }
        return this.http.get(url,{search: params, headers: headers}).map((responseData) => responseData.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/service/task.service.ts